import { useQuery, useMutation } from 'react-query';
import { request } from '../utils/axios-utils';

const fetchStudioUsers = (id) => {
    if (id) {
        return request({ url: `/studio/users/${id}`, method: 'GET' })
    }
    else {
        return [];
    }
}

const addStudioUser = (id, data) => {
    return request({ url: `/studio/users/${id}`, method: 'POST', data })
}

export const useStudioUsers = (id, onSuccess, onError, transFormData) => {
    return useQuery(`studioUsers_${id}`, () => fetchStudioUsers(id), {
        onSuccess: onSuccess ? onSuccess : null,
        onError: onError ? onError : null,
        enabled: false,
        refetchOnWindowFocus: false,
        select: (data) => transFormData ? transFormData(data.data) : data.data,
    });
}

export const useAddStudioUser = (id, onSuccess, onError) => {
    return useMutation((data) => addStudioUser(id, data), {
        onSuccess: onSuccess ? onSuccess : null,
        onError: onError ? onError : null,
    });
}


